import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { Message } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth' // getToken from cookie
import { fetchBusinessType } from '@/utils/index'
import { getIntentionTags } from '@/utils/intentionTags/index' // 不重定向白名单
import { setBuryPoint } from './api/Account'
import { i18n } from '@/main'
import { ssoLoginCodeErrConfig } from '@/utils/config'

NProgress.configure({ showSpinner: false }) // NProgress configuration

let startTime = Date.now()
let currentTime
router.beforeEach((to, from, next) => funcBeforeEach(to, from, next))

export function funcBeforeEach(to, from, next) {
  // console.info('触发路由跳转', to, from)
  // if (window.__POWERED_BY_QIANKUN__) {
  //   return
  // }

  if (to.matched[0] && to.matched[0].meta.businessType !== 'operating') {
    // 通过当前页面的业务类型，设置相关业务信息，并通过store共享,区分demo模块
    fetchBusinessType(to.matched[0].meta.businessType)
  }
  NProgress.start()
  if (to && from.name) {
    let product = from.matched[0].meta.businessType
    currentTime = Date.now()
    // console.log('用户由 ', from.name, ' 页面 跳转到 ', to.name, ' 页面，在 ', from.name, ' 页面停留了 ', currentTime - startTime, '毫秒。转换成秒数约为：', parseInt((currentTime - startTime) / 1000))
    let time_length = currentTime - startTime + ''
    startTime = Date.now()
    // console.log('+++++++ 分割线 +++++++')
    let params = {
      user_id: store.state.user.id || '',
      company_name: store.state.user.company || '',
      product: product || '',
      page: from.name,
      page_event: '',
      time_length: time_length,
      total_width_height: screen.width + '*' + screen.height,
      avail_width_height: screen.availWidth + '*' + screen.availHeight,
      color_depth: screen.colorDepth + '',
      pixel_depth: screen.pixelDepth + '',
      app_version: navigator.appVersion + '',
      user_agent: navigator.userAgent + '',
      loading_time: window.performance.timing.responseEnd - window.performance.timing.requestStart + ''
    }
    setBuryPoint(params)
  }
  // if (from && to.name) {
  //   currentTime = Date.now()
  //   console.log('用户由 ', from.name, ' 页面 跳转到 ', to.name, ' 页面，在 ', from.name, ' 页面停留了 ', currentTime - startTime, '毫秒。转换成秒数约为：', parseInt((currentTime - startTime) / 1000))
  //   startTime = Date.now()
  //   console.log('======== 分割线 ========')
  // }
  store.dispatch('setPageName', to.name)
  // if (window.__POWERED_BY_QIANKUN__) {
  //   next()
  // }

  // 如果不需要登录且非登录页直接next
  if (to.path !== '/login' && to.meta.noNeedLogin) {
    next()
    return
  }
  if (!window.__POWERED_BY_QIANKUN__ && getToken()) {
    if (store.getters.product_and_permission.permissions.length === 0) {
      store
        .dispatch('GetInfo')
        .then(res => {
          // 拉取用户信息
          const { intention_annotate, intention, product_and_permission, company, license_info, routerProducePermissions } = res.data.data

          // const { has_license, expire_days } = license_info
          // if (!window.__POWERED_BY_QIANKUN__) {
          //   if (has_license && expire_days > 7) {
          //     Message.error('The license has been expired. Please renew it.')
          //     removeToken()
          //     next({ path: '/login' })
          //     return
          //   }
          // }

          // 获取用户催收、营销、信审业务对应的意向标签
          getIntentionTags(intention_annotate, intention, company)
          store.dispatch('GenerateRoutes', routerProducePermissions).then(accessRoutes => {
            // 根据roles权限生成可访问的路由表
            // console.info(accessRoutes, 'accessRoutes')
            router.addRoutes(accessRoutes) // 动态添加可访问路由表
            if (to.path === '/login') {
              next({ path: '/' })
              NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
            } else {
              NProgress.done()
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            }
          })
        })
        .catch(() => {
          store.dispatch('FedLogOut').then(() => {
            next({ path: '/' })
          })
        })
    } else {
      next()
    }
  } else {
    if (window.__POWERED_BY_QIANKUN__) {
      next()
    } else if (to.name === 'login') {
      const search = window.location.search
      const params = new URLSearchParams(search)
      const code = +params.get('code')
      const msg = params.get('msg')
      const token = params.get('token')
      const lock_time = params.get('lock_time')
      const remain_times = params.get('remain_times')
      const login_tips = params.get('login_tips')
      let ssoErrMsg = ssoLoginCodeErrConfig[code] // sso错误,找不到没有
      if (ssoErrMsg) ssoErrMsg = i18n.t(ssoErrMsg)
      if (code === 200 && token) {
        store.dispatch('SSOLogin', decodeURI(token)).then(() => {
          if (login_tips) {
            sessionStorage.setItem('loginTips', login_tips.replaceAll(`'`, `"`))
          }
          window.location.href = window.location.origin
        })
      } else if ([3, 4, 5, 6].includes(code) || ssoErrMsg) {
        let message = ssoErrMsg
        switch (code) {
        case 3:
          message = i18n.t('security.moreTip')
          break
        case 4:
          message = i18n.t('security.forTip')
          break
        case 5:
          message = i18n.t('security.lockTip', {
            errorMin: Math.ceil(lock_time / 60)
          })
          break
        case 6:
          message = i18n.t('security.loginLockTip', {
            errorNum: remain_times,
            errorMin: Math.ceil(lock_time / 60)
          })
          break
        case 7:
          message = i18n.t('login.noRegister')
          break
        case 8:
          message = i18n.t('login.noCanSSO')
          break
        }
        Message.error(message)
      } else if (msg) {
        Message.error(msg)
      }
      next()
      NProgress.done()
    } else {
      next('/login')
      NProgress.done()
    }
  }
}



// WEBPACK FOOTER //
// ./src/permission.js